import { OnInit, Component, ViewChild, Output, EventEmitter } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { StructureUserRole } from "../../../structure/structure-users.model";
import { UserDetailsPositionComponent } from "./user-details-position.component";
import { Subscription } from "rxjs";
import { UserDetailsRest } from "../user-details.rest";
import { GridComponent } from "../../../../core/shared/grid/grid.component";
import { UserPositionRow } from "../../users.model";
import { HasPermissions, Permissions } from "../../../../core/services/permissions/permissions.model";
import { PermissionsService } from "../../../../core/services/permissions/permissions.service";

@Component({
  selector: 'smp-user-positions',
  templateUrl: 'user-details-positions.component.html',
  //styleUrls: ['../rating-definition.component.scss']
})

export class UserDetailsPositionsComponent implements OnInit, HasPermissions {
  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }
  constructor(
    private router: Router,
    private route: ActivatedRoute, private rest: UserDetailsRest,
    private permissionService: PermissionsService) {
  }

  public userDetailsModel: any;
  private userName: String;
  public path: String;
  private messageBoxSubscription: Subscription;
  @ViewChild("positionsGrid") positionsGrid: GridComponent;
  public userDetailsPositionComponent: UserDetailsPositionComponent;
  @Output() onPositionAdd = new EventEmitter<any>();

  private headers = [
    { displayName: 'Pozycja', propertyName: 'roleName', propertyType: 'string' },
    { displayName: 'Od', propertyName: 'dateFrom', propertyType: 'string' },
    { displayName: 'Do', propertyName: 'dateTo', propertyType: 'string' },
    { displayName: 'Wynagrodzenie', propertyName: 'salary', propertyType: 'number' }
  ];

  ngOnInit() {
    this.setPermissions("User");
    if (this.route.snapshot.params['UserName'] && this.route.snapshot.params['UserName'] != '0') {

      this.route.params.subscribe(params => {
        this.userName = params['UserName'];
        this.path = `api/user/positions/${this.userName}`;
      });
    }
  }

  public setModel(userDetailsPositionComponent: UserDetailsPositionComponent) {
    this.userDetailsPositionComponent = userDetailsPositionComponent;
  }

  private getActionButtons() {
    return [];
  }

  private onRowAdd() {
    this.onPositionAdd.emit();
  }

  private onRowEdit(row: UserPositionRow) {
    this.userDetailsPositionComponent.openForEdit(row);
  }

  private onRowDelete(row: UserPositionRow) {

    sweetAlert("Czy usunąć pozycję zatrudnienia?", {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "yes":
            this.rest.deleteUserPosition(row.id).subscribe(() => {
              sweetAlert("Pozycja zatrudnienia została usunięta.");
              this.positionsGrid.refreshAndLoadData();
            });

            break;
        }
      });
  }

  public onSuccessOperation() {
    this.positionsGrid.refreshAndLoadData();
  }
}